import { Divider } from 'antd';

const Xembify = () => {
  return (
    <>
      <div className="bg-[#f3f3f3] p-4 md:p-8 pt-4 rounded-md">
        <Divider />
        <p className="m-2 font-bold">Important Safety Information</p>

        <p className="m-2 font-bold">Indication</p>

        <p className="m-2">
          XEMBIFY® (immune globulin subcutaneous human–klhw) is a 20% immune globulin indicated for
          treatment of primary humoral immunodeficiency disease (PIDD) in patients 2 years of age
          and older. XEMBIFY is for subcutaneous administration only
        </p>

        <p className="m-2 font-bold">Important Safety Information</p>

        <div className="m-2 font-bold">
          WARNING: THROMBOSIS
          <p className="m-2 ml-10">
            • Thrombosis may occur with immune globulin products, including XEMBIFY. Risk factors
            may include: advanced age, prolonged immobilization, hypercoagulable conditions, history
            of venous or arterial thrombosis, use of estrogens, indwelling vascular catheters,
            hyperviscosity, and cardiovascular risk factors. Thrombosis may occur in the absence of
            known risk factors
          </p>
          <p className="m-2 ml-10">
            • For patients at risk of thrombosis, administer XEMBIFY at the minimum dose and
            infusion rate practicable. Ensure adequate hydration in patients before administration.
            Monitor for signs and symptoms of thrombosis and assess blood viscosity in patients at
            risk of hyperviscosity
          </p>
        </div>

        <p className="m-2 font-bold underline">Contraindications</p>

        <p className="m-2">
          XEMBIFY is contraindicated in patients who have had an anaphylactic or severe systemic
          reaction to the administration of human immune globulin. It is contraindicated in
          IgA-deficient patients with antibodies against IgA and a history of hypersensitivity.
        </p>

        <p className="m-2 font-bold underline">Warnings and Precautions</p>

        <p className="m-2">
          <b>Hypersensitivity. </b>
          Severe hypersensitivity reactions may occur with immune globulin products, including
          XEMBIFY. In case of hypersensitivity, discontinue infusion immediately and institute
          appropriate treatment. XEMBIFY contains IgA. Patients with known antibodies to IgA may
          have a greater risk of developing potentially severe hypersensitivity and anaphylactic
          reactions.
        </p>

        <p className="m-2">
          <b>Thrombosis. </b>
          Thrombosis may occur following treatment with immune globulin products, including XEMBIFY.
          Thrombosis may occur in the absence of known risk factors. In patients at risk, administer
          at the minimum dose and infusion rate practicable. Ensure adequate hydration before
          administration. Monitor for signs and symptoms of thrombosis and assess blood viscosity in
          patients at risk of hyperviscosity.
        </p>

        <p className="m-2">
          <b>Aseptic meningitis syndrome (AMS). </b>
          AMS may occur with human immune globulin treatment, including XEMBIFY. Conduct a thorough
          neurological exam on patients exhibiting signs and symptoms to rule out other causes of
          meningitis. Discontinuation of treatment has resulted in remission within several days
          without sequelae.
        </p>

        <p className="m-2">
          <b>Renal dysfunction/failure. </b>
          Acute renal dysfunction/failure, acute tubular necrosis, proximal tubular nephropathy,
          osmotic nephrosis, and death may occur with use of human immune globulin products,
          especially those containing sucrose. XEMBIFY does not contain sucrose. Ensure patients are
          not volume-depleted prior to starting infusion. In patients at risk due to preexisting
          renal insufficiency or predisposition to acute renal failure, assess renal function prior
          to the initial infusion of XEMBIFY and again at appropriate intervals thereafter. If renal
          function deteriorates, consider discontinuation.
        </p>

        <p className="m-2">
          <b>Hemolysis. </b>
          XEMBIFY may contain blood group antibodies that may cause a positive direct antiglobulin
          reaction and hemolysis. Monitor patients for clinical signs and symptoms of hemolysis. If
          signs and symptoms are present after infusion, perform confirmatory lab testing.
        </p>

        <p className="m-2">
          <b>Transfusion-related acute lung injury (TRALI). </b>
          Noncardiogenic pulmonary edema may occur in patients following treatment with immune
          globulin products, including XEMBIFY. Monitor patients for pulmonary adverse reactions. If
          TRALI is suspected, perform appropriate tests for the presence of antineutrophil and
          anti-HLA antibodies in both the product and patient serum. TRALI may be managed using
          oxygen therapy with adequate ventilatory support.
        </p>

        <p className="m-2">
          <b>Transmissible infectious agents. </b>
          Because XEMBIFY is made from human blood, it may carry a risk of transmitting infectious
          agents, eg, viruses, the variant Creutzfeldt-Jakob disease (vCJD) agent, and,
          theoretically, the Creutzfeldt-Jakob disease (CJD) agent. No cases of transmission of
          viral diseases, vCJD, or CJD have ever been associated with the use of XEMBIFY.
        </p>

        <p className="m-2">
          <b>Interference with lab tests. </b>
          After infusion of XEMBIFY, passively transferred antibodies in the patient’s blood may
          yield positive serological testing results, with the potential for misleading
          interpretation.
        </p>

        <p className="m-2 font-bold underline">Adverse Reactions</p>

        <p className="m-2">
          The most common adverse reactions in ≥5% of subjects in the clinical trial were local
          adverse reactions, including infusion-site erythema (redness), infusion-site pain,
          infusion-site swelling (puffiness), infusion-site bruising, infusion-site nodule,
          infusion-site pruritus (itching), infusion-site induration (firmness), infusion-site scab,
          infusion-site edema, and systemic reactions including cough and diarrhea.
        </p>

        <p className="m-2 font-bold underline">Drug Interactions</p>

        <p className="m-2">
          Passive transfer of antibodies may transiently interfere with the immune responses to live
          attenuated virus vaccines (eg, measles, mumps, rubella, and varicella).
        </p>

        <div>
          <p className="m-2">
            <b>
              Please see&nbsp;
              <a
                target="_blank"
                href="/Xembify-Prescribing-Information.pdf"
                className="text-blue-500 hover:underline"
              >
                full Prescribing Information
              </a>
              &nbsp;for XEMBIFY.
            </b>
          </p>
          <p className="m-2">
            <b>
              You are encouraged to report negative side effects of prescription drugs to the FDA.
              Visit&nbsp;
              <a
                target="_blank"
                href="http://www.fda.gov/medwatch"
                className="text-blue-500 hover:underline"
              >
                www.fda.gov/medwatch
              </a>
              &nbsp;or call 1-800-FDA-1088.
            </b>
          </p>
        </div>
      </div>
    </>
  );
};

export default Xembify;
